import React, { useState } from 'react';
import { FilterBar } from './FilterBar';
import { FilterModal } from './FilterModal';
import { ActiveFilter } from '../types/filters';
import { WalletBadge } from './billing/WalletBadge';
export function Header() {
  const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const handleRemoveFilter = (filterId: string) => {
    setActiveFilters(prev => prev.filter(f => f.filterId !== filterId));
  };
  const handleOpenFilters = () => {
    setIsFilterModalOpen(true);
  };
  const handleApplyFilters = (filters: ActiveFilter[]) => {
    setActiveFilters(filters);
  };
  return <>
      <header className="border-b border-gray-200 px-6 py-3 bg-white" data-id="element-729">
        <div className="flex items-center justify-between" data-id="element-730">
          <div className="flex-1" data-id="element-731" />
          <div className="flex items-center gap-4" data-id="element-732">
            <WalletBadge data-id="element-733" />
            <FilterBar activeFilters={activeFilters} onRemoveFilter={handleRemoveFilter} onOpenFilters={handleOpenFilters} data-id="element-734" />
          </div>
        </div>
      </header>

      <FilterModal isOpen={isFilterModalOpen} onClose={() => setIsFilterModalOpen(false)} activeFilters={activeFilters} onApplyFilters={handleApplyFilters} data-id="element-735" />
    </>;
}